// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Oman from '../_raw/flag/icon_flag_oman.png';

export default () => <img src={Oman} alt="Oman" />;
